exports.onClientEntry = () => {
  // eslint-disable-next-line global-require
  require('core-js/actual/array/find-index');
  // eslint-disable-next-line global-require
  require('core-js/actual/number');
  // eslint-disable-next-line global-require
  require('core-js/actual/object/entries');
  // eslint-disable-next-line global-require
  require('core-js/actual/string/starts-with');
};
